import { Component, OnDestroy, OnInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { RappiderTitleToolbarModule } from '@rappider/rappider-components';
import { RappiderListGridModule } from '@rappider/rappider-components';
import { RappiderButtonModule } from '@rappider/rappider-components';
import { RappiderModalModule } from '@rappider/rappider-components';
import { DataSchemaModule } from '../../modules/data-schema/data-schema.module';
import { RouterModule } from '@angular/router';
import { CustomEndpointModule } from '../../modules/custom-endpoint/custom-endpoint.module';
import { ProjectModelRelationModule } from '../../modules/project-model-relation/project-model-relation.module';
import { TranslateModule } from '@ngx-translate/core';
import { defaultToolbarTitleHeadingSize, PATH_DEFINITIONS, ProjectModelEditOptions, QUERY_PARAM_DEFINITIONS, FullPaths } from '@rappider/shared/definitions';
import { ProjectInterface } from 'libs/shared/src/lib/sdk/models';
import { interval, Subject, Subscription, takeUntil, combineLatest, debounceTime, distinctUntilChanged } from 'rxjs';
import { DATA_FIELD_LIST_CONFIG, CANVAS_FIELD_LIST_CONFIG, GENERATE_DATA_STORE, blackListedFieldNamesForCrudPageConfig } from './config/data-field-list-config';
import { Navigate } from 'libs/shared/src/lib/states/router/router.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionResponse, BreadcrumbOption, ButtonComponentConfig, HeadingComponentConfig, OrderChangeOutput, DropdownMenuItem } from '@rappider/rappider-components/utils';
import { DataSchemaWithRelations, PageWithRelations, ProjectModelField, ProjectModelWithRelations } from '@rappider/rappider-sdk';
import { CreateCrudPagesForProjectModel, GenerateDataStore, GetProjectModels } from '../../states/project-model-state/project-model.actions';
import { DataSchemaDisplayComponentMode } from '../../modules/data-schema/components/data-schema-display/utils/data-schema-field-edit-component-mode.enum';
import { NotificationService, StoreKeys, SyncRemoteDataService } from '@rappider/services';
import { getProjectAndProjectModelsLoading } from './utils/loading-selector';
import { getProjectModelsWithFieldsAndSchemas } from './utils/get-project-model-with-fields-and-schemas';
import { ProjectModelFieldActions } from '@rappider/project-model-field';
import { BulkUpdateProjectModelFields } from 'libs/project-model-field/src/lib/state/project-model-field.actions';
import { ActionButtonConfig } from '../../modules/data-schema/components/data-schema-display/utils/action-buttons.config';
import { DataSchemaDisplayComponent } from '../../modules/data-schema/components/data-schema-display/data-schema-display.component';
import { selectIsDataSchemaLoaded } from '../../states/data-schema/data-schema.selectors';
import { DataFieldEditComponent } from '../data-field-edit/data-field-edit.component';
import { ProjectModelDataFieldCreateComponent } from '../project-model-data-field-create/project-model-data-field-create.component';

@Component({
  selector: 'rappider-data-field-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzToolTipModule,
    NzSpinModule,
    NzEmptyModule,
    NzCardModule,
    NzIconModule,
    NzCollapseModule,
    NzSkeletonModule,
    NzTabsModule,
    NzModalModule,
    RappiderTitleToolbarModule,
    RappiderListGridModule,
    RappiderButtonModule,
    RappiderModalModule,
    DataSchemaModule,
    RouterModule,
    CustomEndpointModule,
    ProjectModelRelationModule,
    TranslateModule,
    DataFieldEditComponent,
    ProjectModelDataFieldCreateComponent
  ],
  templateUrl: './data-field-list.component.html',
  styleUrls: ['./data-field-list.component.scss']
})
export class DataFieldListComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild(DataSchemaDisplayComponent) dataSchemaDisplay: DataSchemaDisplayComponent;
  @Input() projectModelId: string;
  @Input() isCanvasMode = false;
  @Input() customListGridConfig: any = null;

  // Tab state for canvas mode
  activeTabIndex = 0;

  DATA_FIELD_LIST_CONFIG = DATA_FIELD_LIST_CONFIG;
  CANVAS_FIELD_LIST_CONFIG = CANVAS_FIELD_LIST_CONFIG;

  /* main title */
  mainTitle: HeadingComponentConfig = {
    content: 'PROJECT_MODULE.PROJECT_MODEL_DATA_FIELD_LIST_COMPONENT.DATA_MODEL_DETAILS',
    type: defaultToolbarTitleHeadingSize
  };
  /* subscriptions */
  subscriptions: Subscription[];
  /* page title */
  title: string[] | BreadcrumbOption[];
  /* active project id */
  activeProjectId: string;
  /* list config */
  /* select component options for project models */
  projectModelSelectOptions: { key: string; value: string }[];
  /* active project */
  activeProject: {
    id: string;
    name: string;
  };
  layouts: PageWithRelations[];
  /* active project model */
  activeProjectModel: ProjectModelWithRelations;
  /* flag for loading state of create crud pages endpoint */
  isCrudPagesLoading = false;
  /*  */
  isDataSchemaFieldModalVisible = false;
  /* project model loading state */
  isProjectModelsLoading = false;
  /* data schemas loading state */
  isDataSchemasLoading = false;
  /*  */
  activeDataSchema: DataSchemaWithRelations;
  /*  */
  dataSchemas: DataSchemaWithRelations[];
  /*  */
  dataSchemaDisplayComponentMode: DataSchemaDisplayComponentMode;
  isLoading: boolean;
  isProjectModelLoaded: boolean;
  isLoaded: boolean;

  QUERY_PARAM_DEFINITIONS = QUERY_PARAM_DEFINITIONS;
  displayToolbar = false;
  displayToolbarBackButton = false;
  titleBarActionButtons: ButtonComponentConfig[] = [];
  generatingDataStoreModelIds: Array<string>;

  isProjectModelFieldsLoading: boolean;
  isProjectModelFieldsLoaded: boolean;
  isFieldsLoadingForModel: boolean;

  replaceExistingCrudPages = false;
  showReplaceModal = false;
  ActionButtonConfig = ActionButtonConfig;
  currentStep = 0;
  private pollingModelField$ = new Subject<void>();

  // Edit modal properties
  isEditFieldModalVisible = false;
  editingFieldId: string;
  private isRefreshing = false;

  // Create field modal properties
  isCreateFieldModalVisible = false;

  constructor(
    private store: Store<any>,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private router: Router,
    private syncRemoteDataService: SyncRemoteDataService
  ) { }

  ngOnInit(): void {
    this.getProjectModelIdFromUrl();
    this.subscribeToData();
    if (this.isCanvasMode) {
      this.activeTabIndex = 0;
    }

    interval(5000).pipe(
      takeUntil(this.pollingModelField$)
    ).subscribe(() => {
      this.syncRemoteDataService.syncRemoteDataItemWithKey(this.activeProject?.id, StoreKeys.ProjectModelField);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectModelId'] && changes['projectModelId'].currentValue) {
      this.projectModelId = changes['projectModelId'].currentValue;
      this.subscribeToData();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.pollingModelField$.next();
    this.pollingModelField$.complete();
  }

  /**
   * sets/updates title bar action button config
   * there is only one button, so we dont spread the array
   *
   * @memberof DataFieldListComponent
   */

  subscribeToData() {
    this.subscriptions = [
      this.subscribeToActiveProject(),
      this.subscribeToProjectModels(),
      this.subscribeToProjectModelsLoading(),
      this.subscribeToDataSchemasLoading(),
      this.subscribeToGenerateCrudPagesForProjectModelLoading(),
      this.subscribeToGeneratingDataStoreModelIds(),
      this.subscribeToLoading(),
      this.subscribeToProjectModelsLoaded(),
      this.subscribeToProjectModelFieldsLoading(),
      this.subscribeToProjectModelFieldsLoaded(),
      this.subscribeToFieldsLoadingProjectModelIds(),
      this.subscribeToLayouts(),
      this.subscribeToUpdateProjectModelFieldSuccessful()
    ];
  }

  /**
   * subscribe to active project to set the title
   *
   * @returns
   * @memberof DataFieldListComponent
   */
  subscribeToActiveProject() {
    return this.store.select(state => state.activeProject.data).subscribe((activeProject: ProjectInterface) => {
      this.activeProject = {
        id: activeProject?.id,
        name: activeProject?.name
      };
      this.syncRemoteDataService.syncRemoteDataItemWithKey(activeProject?.id, StoreKeys.MonitorApplication);
    });
  }

  subscribeToGenerateCrudPagesForProjectModelLoading() {
    return this.store.select(state => state.projectModel?.isCrudPagesLoading).subscribe((isCrudPagesLoading: boolean) => {
      if (this.isCrudPagesLoading && !isCrudPagesLoading) {
        this.toggleEditDataSchemaFieldModalVisibility();
      }
      this.isCrudPagesLoading = isCrudPagesLoading;
    });
  }

  subscribeToGeneratingDataStoreModelIds() {
    return this.store.select(state => state.projectModel?.generatingDataStoreModelIds).subscribe((generatingDataStoreModelIds: Array<string>) => {
      this.generatingDataStoreModelIds = generatingDataStoreModelIds;

      if (this.activeProjectModel) {
        const isDataStoreCurrentlyGenerating = generatingDataStoreModelIds.some(generatingDataStoreModelId => generatingDataStoreModelId === this.activeProjectModel.id);
        if (isDataStoreCurrentlyGenerating) {
          this.notificationService.createNotification(
            'info',
            this.activeProjectModel.name,
            'Generating Data Store',
          );
        }
      }
    });
  }

  getProjectModelIdFromUrl() {
    if (!this.projectModelId) {
      this.projectModelId = this.activatedRoute.snapshot.params['projectModelId'];
    }

    // Only navigate if not in canvas mode
    if (!this.isCanvasMode && !this.activatedRoute.snapshot.queryParams['tab'] && this.projectModelId) {
      this.router.navigate([`${PATH_DEFINITIONS.PROJECTS.PROJECT_MODEL_DATA_FIELD_LIST}`, this.projectModelId], { queryParams: { tab: this.QUERY_PARAM_DEFINITIONS.PROJECT.DATA_FIELD_LIST_COMPONENT.FIELDS_TAB.tab } });
    }
  }

  subscribeToProjectModels() {
    return combineLatest([
      this.store.select(<any>getProjectModelsWithFieldsAndSchemas),
      this.activatedRoute.params
    ]).subscribe(([projectModelsWithFieldsAndSchemas, params]) => {
      const currentProjectModelId = params['projectModelId'] || this.projectModelId;

      if (projectModelsWithFieldsAndSchemas && currentProjectModelId) {
        this.activeProjectModel = projectModelsWithFieldsAndSchemas.projectModels.find(projectModel => projectModel.id === currentProjectModelId);

        if (this.activeProjectModel) {
          this.activeProjectModel.fields = this.activeProjectModel.fields?.map(projectModelField => ({
            ...projectModelField,
            type: projectModelField.isArray && !projectModelField.type.includes('[]') ? `${projectModelField.type} []` : projectModelField.type
          }));
          this.dataSchemas = projectModelsWithFieldsAndSchemas.dataSchemas;
          this.activeDataSchema = projectModelsWithFieldsAndSchemas.dataSchemas?.find(dataSchema => dataSchema.id === this.activeProjectModel?.relationedTypeId);
          if (this.activeDataSchema) {
            this.activeDataSchema = {
              ...this.activeDataSchema,
              fields: this.activeDataSchema.fields?.filter(field =>
                !field.isNavigationalProperty &&
                !(field.isId || field.isMixin) &&
                !blackListedFieldNamesForCrudPageConfig.includes(field.name)
              )
            };
          }
          this.setEditModelDropdownOptions();
          this.setTitle();
        } else {
          this.activeProjectModel = null;
          this.activeDataSchema = null;
        }
      } else {
        this.activeProjectModel = null;
        this.activeDataSchema = null;
      }
    });
  }

  subscribeToProjectModelsLoading() {
    return this.store.select(state => state.projectModel?.loading).subscribe((isLoading: boolean) => {
      this.isProjectModelsLoading = isLoading;
    });
  }

  subscribeToProjectModelFieldsLoading() {
    return this.store.select(state => state.projectModelField?.isLoading).subscribe((isLoading: boolean) => {
      this.isProjectModelFieldsLoading = isLoading;
    });
  }

  subscribeToDataSchemasLoading() {
    return this.store.select(selectIsDataSchemaLoaded).subscribe((isLoaded: boolean) => {
      this.isDataSchemasLoading = !isLoaded;
    });
  }

  subscribeToLayouts() {
    return this.store.select(state => state.layout?.data).subscribe(layouts => {
      this.layouts = layouts ?? [];
    });
  }

  setEditModelDropdownOptions() {
    this.DATA_FIELD_LIST_CONFIG.listActions = this.DATA_FIELD_LIST_CONFIG.listActions.map(listAction => {
      if (listAction.name === 'editDataModel') {
        if (this.activeProjectModel?.generateUIDataStore || !this.activeProjectModel?.isDeletable) {
          return {
            ...listAction,
            dropdownConfig: {
              ...listAction.dropdownConfig,
              items: listAction.dropdownConfig.items.filter(action => action.key !== 'GenerateDataStore')
            }
          };
        } else {
          return {
            ...listAction,
            dropdownConfig: {
              ...listAction.dropdownConfig,
              items: listAction.dropdownConfig.items.some(action =>
                action.key === 'GenerateDataStore') ? listAction.dropdownConfig.items : [...listAction.dropdownConfig.items, GENERATE_DATA_STORE]
            }
          };
        }
      } else {
        return listAction;
      }
    });
  }

  subscribeToLoading() {
    return this.store.select(<any>getProjectAndProjectModelsLoading).subscribe(loading => {
      this.isLoading = loading;
    });
  }

  subscribeToProjectModelFieldsLoaded() {
    return this.store.select(state => state.projectModelField.isLoaded).subscribe(isLoaded => {
      this.isProjectModelFieldsLoaded = isLoaded;
    });
  }

  subscribeToFieldsLoadingProjectModelIds() {
    return combineLatest([
      this.store.select(state => state.projectModelField.fieldsLoadingModelIds),
      this.activatedRoute.params
    ]).subscribe(([fieldsLoadingModelIds, params]) => {
      const currentProjectModelId = params['projectModelId'];
      this.isFieldsLoadingForModel = fieldsLoadingModelIds?.some(id => id === currentProjectModelId);
    });
  }

  subscribeToProjectModelsLoaded() {
    return this.store.select(state => state.projectModel.isLoaded).subscribe(isLoaded => {
      this.isLoaded = isLoaded;
    });
  }

  setTitle() {
    this.title = [
      {
        label: this.activeProject?.name,
        redirectUrl: `${PATH_DEFINITIONS.PROJECTS.PROJECT_DETAIL_PATH}/${this.activeProject?.id}`
      },
      {
        label: 'PROJECT_MODULE.PROJECT_MODEL_DATA_FIELD_LIST_COMPONENT.DATA_MODELS',
        redirectUrl: PATH_DEFINITIONS.PROJECTS.PROJECT_MODEL_LIST
      },
      {
        label: this.activeProjectModel?.name,
      },
      {
        label: 'PROJECT_MODULE.PROJECT_MODEL_DATA_FIELD_LIST_COMPONENT.DATA_MODEL_DETAILS'
      }
    ];
  }

  navigateCreateDataFieldPage() {
    if (!this.isCanvasMode) {
      const currentProjectModelId = this.activatedRoute.snapshot.params['projectModelId'];
      this.store.dispatch(new Navigate({ url: `${PATH_DEFINITIONS.PROJECTS.PROJECT_MODEL_DATA_FIELD_CREATE}/${currentProjectModelId}` }));
    } else {
      // In canvas mode, open the create field modal
      this.openCreateFieldModal();
    }
  }

  /**
   * event that will be fired whenever list order changed
   *
   * @param {OrderChangeOutput} orderChangeData
   * @memberof DataFieldListComponent
   */
  onOrderChange(orderChangeData: OrderChangeOutput) {

    /* check if any of the items are not updatable */
    const hasNonUpdatableItem = orderChangeData.data.some(item => item.isUpdatable === false);
    if (hasNonUpdatableItem) {
      this.notificationService.createNotification(
        'error',
        'Order Change Failed',
        'Only updatable data fields can be reordered.'
      );

      this.activeProjectModel.fields = [...this.activeProjectModel.fields];
      return;
    }

    /* start index of ordered item */
    let startIndex = orderChangeData.orderStartIndex;

    /* new indices of changed data */
    const updatedProjectModelDataFields = orderChangeData.data.map((item: ProjectModelField) => {
      const dataFieldWithNewIndex = {
        id: item.id,
        index: startIndex
      };
      startIndex++;
      return dataFieldWithNewIndex;
    });

    const currentProjectModelId = this.activatedRoute.snapshot.params['projectModelId'];
    this.store.dispatch(BulkUpdateProjectModelFields({ payload: { projectModelId: currentProjectModelId, projectModelFields: updatedProjectModelDataFields } }));
  }

  onDeleteDataFieldClick(response: ActionResponse) {
    const dataFieldToDelete = <ProjectModelField>response.data;

    const currentProjectModelId = this.activatedRoute.snapshot.params['projectModelId'];
    this.store.dispatch(ProjectModelFieldActions.DeleteProjectModelField(
      {
        payload: {
          projectModelFieldId: dataFieldToDelete.id,
          projectModelId: currentProjectModelId,
          relationedTypeId: this.activeProjectModel?.relationedTypeId
        }
      }
    ));
  }

  onEditDataFieldClick(response: ActionResponse) {
    const dataFieldToEdit = <ProjectModelField>response.data;

    if (this.isCanvasMode) {
      this.editingFieldId = dataFieldToEdit.id;
      this.isEditFieldModalVisible = true;
    } else {
      this.router.navigate([`${PATH_DEFINITIONS.PROJECTS.PROJECT_MODEL_DATA_FIELD_EDIT}`, dataFieldToEdit.id]);
    }
  }

  onItemActionClick(response: ActionResponse) {
    if (response.action?.name === 'edit') {
      this.onEditDataFieldClick(response);
    } else if (response.action?.name === 'DELETE_ITEM') {
      this.onDeleteDataFieldClick(response);
    }
  }

  createCrudPagesForProjectModel() {
    this.store.dispatch(new CreateCrudPagesForProjectModel({ projectModel: this.activeProjectModel, replaceExistingCrudPages: this.replaceExistingCrudPages }));
  }

  toggleEditDataSchemaFieldModalVisibility() {
    this.isDataSchemaFieldModalVisible = !this.isDataSchemaFieldModalVisible;
  }

  setEditDataSchemaFieldModalTitle() {
    return `${this.activeProjectModel.name} Data Schema Fields`;
  }
  onListActionDropdownItemClick(action: DropdownMenuItem) {
    if (action.key === ProjectModelEditOptions.EditDataSchemaOptions) {
      this.dataSchemaDisplayComponentMode = DataSchemaDisplayComponentMode.Edit;
      this.toggleEditDataSchemaFieldModalVisibility();
    } else if (action.key === ProjectModelEditOptions.GenerateCrudPages) {
      if (this.activeProjectModel?.isEachCRUDPageGenerated) {
        this.openReplaceModal();
      } else {
        this.openGenerateCrudPageModal();
      }
    } else if (action.key === ProjectModelEditOptions.GenerateDataStore) {
      const currentProjectModelId = this.activatedRoute.snapshot.params['projectModelId'];
      this.store.dispatch(new GenerateDataStore({
        projectModelId: currentProjectModelId
      }));
    }
  }

  /**
   * Navigate to AI generate data model component for editing
   */
  navigateToEditWithAI(): void {
    if (this.activeProjectModel?.name) {
      const route = `${FullPaths.GenerateDataModelWithAi}/edit/${this.activeProjectModel.name}`;
      this.router.navigateByUrl(route);
    }
  }

  /**
   * Handle list action clicks including AI update functionality
   */
  onListActionClick(action: any) {
    const actualAction = action?.action;

    if (actualAction?.name === 'updateDataModelWithAI') {
      this.navigateToEditWithAI();
    } else {
      this.navigateCreateDataFieldPage();
    }
  }

  openReplaceModal() {
    this.showReplaceModal = true;
  }

  closeReplaceModal() {
    this.showReplaceModal = false;
  }

  openGenerateCrudPageModal() {
    this.closeReplaceModal();
    this.dataSchemaDisplayComponentMode = DataSchemaDisplayComponentMode.GenerateCRUDPages;
    this.toggleEditDataSchemaFieldModalVisibility();
  }

  changeReplacePageOption(replaceExistingCrudPages: boolean) {
    this.replaceExistingCrudPages = replaceExistingCrudPages;
    this.openGenerateCrudPageModal();
  }

  onCurrentStepChange(currentStep) {
    this.currentStep = currentStep;
  }

  onClickSkip() {
    this.dataSchemaDisplay.onClickSkip();
  }

  onClickSave() {
    this.dataSchemaDisplay.onClickSave();
  }

  onClickBack() {
    this.dataSchemaDisplay.onClickBack();
  }

  generateCRUDPages() {
    this.dataSchemaDisplay.generateCRUDPages();
  }

  onClickHelp() {
    this.dataSchemaDisplay.onClickHelp();
  }

  onTabClick(tabIndex: number) {
    if (this.isCanvasMode) {
      this.activeTabIndex = tabIndex;
    }
  }

  onEditFieldModalClose() {
    this.isEditFieldModalVisible = false;
    this.editingFieldId = null;
  }

  openCreateFieldModal() {
    this.isCreateFieldModalVisible = true;
  }

  onCreateFieldModalClose() {
    this.isCreateFieldModalVisible = false;
  }

  subscribeToUpdateProjectModelFieldSuccessful() {
    return this.store.select(state => state.projectModel?.updateProjectModelFieldSuccessful)
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((success) => {
        if (success && this.isCanvasMode && !this.isRefreshing) {
          this.isRefreshing = true;
          this.onEditFieldModalClose();
          this.onCreateFieldModalClose();
          setTimeout(() => {
            this.store.dispatch(new GetProjectModels());
            this.isRefreshing = false;
          }, 500);
        }
      });
  }
}
